import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

interface IControllerSupportsFeature {
	options: { showAppliances: boolean }
}

type ApplianceFeatureParams = FeatureHoookParams;
export const useShowApplianceFeature = (_params: ApplianceFeatureParams = {}): Feature<boolean> => {
	const [controller] = useDesign<Controller, IControllerSupportsFeature>();

	useSubscription(controller, false, [['layer-option-appliance', '*']]);

	const controllerSupportsFeature = (controller?.options?.showAppliances ?? null) !== null;
	const showLayer = controller?.options?.showAppliances ?? true;

	const tooltip = (() => {
		const showHide = showLayer ? lang.layer.tooltip.hide : lang.layer.tooltip.show;
		return `${showHide} ${lang.layer.label.appliances} ${lang.layer.layer}`;
	})();

	return {
		name: 'showAppliance',
		label: lang.layer.label.appliances,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled: !controllerSupportsFeature,
		value: showLayer,
		hidden: false,
		handler: () => {
			if (controller) {
				controller.options.showAppliances = !showLayer;
			}
		}
	};
};
